<template>
  <div id="media" class="container">
    <div class="center">
      <img src="../../../assets/media_title.jpg"/>
    </div>

    <gallery :images="images" :index="index" @close="index = null" :options="options"></gallery>
    <div id="imageGallery" class="row">
      <a
        class="col-md-3 col-sm-4 col-xs-6"
        v-for="(image, imageIndex) in thumbs"
        :key="imageIndex"
        @click="index = imageIndex">
        <img :src="image"/>
      </a>
    </div>

    <!--<div id="imageGallery" class="row">-->
    <!--<a href="../../../assets/goj_gallery1.jpg" class="col-md-3 col-sm-4 col-xs-6"><img-->
    <!--src="../../../assets/goj_thumb1.jpg"/></a>-->
    <!--<a href="../../../assets/goj_gallery2.jpg" class="col-md-3 col-sm-4 col-xs-6"><img-->
    <!--src="../../../assets/goj_thumb2.jpg"/></a>-->
    <!--<a href="../../../assets/goj_gallery3.jpg" class="col-md-3 col-sm-4 col-xs-6"><img-->
    <!--src="../../../assets/goj_thumb3.jpg"/></a>-->
    <!--<a href="../../../assets/goj_gallery4.jpg" class="col-md-3 col-sm-4 col-xs-6"><img-->
    <!--src="../../../assets/goj_thumb4.jpg"/></a>-->
    <!--<a href="../../../assets/goj_gallery5.jpg" class="col-md-3 col-sm-4 col-xs-6"><img-->
    <!--src="../../../assets/goj_thumb5.jpg"/></a>-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  data () {
    return {
      images: ['static/images/goj_gallery1.jpg', 'static/images/goj_gallery2.jpg', 'static/images/goj_gallery3.jpg', 'static/images/goj_gallery4.jpg', 'static/images/goj_gallery5.jpg'],
      thumbs: ['static/images/goj_thumb1.jpg', 'static/images/goj_thumb2.jpg', 'static/images/goj_thumb3.jpg', 'static/images/goj_thumb4.jpg', 'static/images/goj_thumb5.jpg'],
      index: null,
      options: {closeOnSlideClick: true}
    }
  }
}
</script>

<style lang="scss" scoped>
  .center {
    margin: 3em auto !important;

    @media all and (max-width: 540px) {
      width: initial;
      margin-top: 1em!important;
    }
  }

  img {
    width: 100%;
  }

  /deep/ .blueimp-gallery {
    .slides > .slide > .slide-content {
      max-width: 90%;
    }
    > .prev, > .next {
      font-weight: 300;
      opacity: 1;
      border: 2px solid #fff;
    }

    > .close {
      top: 30%;
      width: 40px;
      height: 40px;
      font-size: 60px;
      line-height: 30px;
      border-radius: 23px;
      border: 2px solid #fff;
      display: none;
    }
  }

  #imageGallery {
    max-width: 1200px;
    @media all and (min-width: 1430px) {
      margin: 0 auto;
    }
    @media all and (max-width: 540px) {
      margin: 0 -15px;
    }

    > a > img {
      cursor: pointer;
    }

    > a {
      @media all and (min-width: 1430px) {
        margin-top: 3em;
        padding: 0 3em;
      }

      img:not(:last-child) {
        padding-bottom: 1em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Media/Media.vue